import { supabase } from '../lib/supabase'

export async function submitFeedback({ feedback_type, message, context }) {
  const { data: { user } } = await supabase.auth.getUser()

  const { data, error } = await supabase
    .from('feedback')
    .insert({
      user_id: user.id,
      feedback_type,
      message,
      context,
    })
    .select()
    .single()

  if (error) throw error
  return data
}
